import type {
  CoveragePlanDatesRequest,
  CoveragePlanDatesResponse,
  ModifiedCoveragePlanDatesPeriod,
} from "@/model/coverage-years";
import type { SpendSummary } from "@/model/spend-summary";
import type { IUserInfo } from "@/hooks/use-user-info";
import httpClient from "@/services";
import type { PlanCoverageInfo } from "@/model/demographics";
import { COVERAGE_CODE } from "@/constants";

export const fetchSpendSummary = async (
  userInfo: IUserInfo,
  selectedCoverageDate?: ModifiedCoveragePlanDatesPeriod | null,
  activeCoverage?: PlanCoverageInfo,
): Promise<SpendSummary> => {
  const defaultParams = {
    // loginGroupId: userInfo.loginGroupId,
    memberId: userInfo.memberId,
    groupId: userInfo.groupId,
    divisionId: userInfo.divisionId,
    planId: activeCoverage?.planId ?? userInfo?.planId,
    claimCoverageCode:
      selectedCoverageDate?.claimCoverageCode ??
      activeCoverage?.claimCoverageCode,
  };
  let params;
  const url = "/spendSummary/spendSummary";
  if (selectedCoverageDate) {
    params = {
      ...defaultParams,
      coverageStartDate: selectedCoverageDate?.startDate,
      coverageEndDate: selectedCoverageDate?.endDate,
    };
  }
  const config = {
    params: params || defaultParams,
    headers: {
      Authorization: `Bearer ${userInfo.accessToken}`,
      "Content-Type": "application/json",
      "Accept-Version": "9.0",
    },
  };

  return httpClient.get(url, config).then((res) => {
    if (
      activeCoverage?.claimCoverageCode === COVERAGE_CODE.VISION ||
      activeCoverage?.claimCoverageCode === COVERAGE_CODE.ORTHODONTIA
    ) {
      const response = {
        data: [],
        header: {
          additionalMessage: "Your vision data will be available soon.",
          message:
            "Your vision data will be available soon. Please check back later.",
          planStartDate: "",
          planEndDate: "",
        },
        summary: {
          ...res.data.summary,
        },
      };

      return response;
    } else {
      return res.data;
    }
  });
};

export const fetchCoverageDates = async (
  requestInfo: CoveragePlanDatesRequest,
): Promise<CoveragePlanDatesResponse> => {
  const url = "/spendSummary/coveragePlanDates";
  const params = {
    employeeId: requestInfo.employeeId,
    groupId: requestInfo.groupId,
    divisionId: requestInfo.divisionId,
    planId: requestInfo.planId,
  };
  const config = {
    params,
    headers: {
      Authorization: `Bearer ${requestInfo.accessToken}`,
      "Content-Type": "application/json",
      "Accept-Version": "2.0",
    },
  };
  return httpClient.get(url, config).then((res) => {
    return res.data as CoveragePlanDatesResponse;
  });
};
